import styled from 'styled-components'
import { blue, textMuted, white } from '@/theme/colors'
import { shadows, radii } from '@/theme/tokens'
import { fontSizes, leading } from '@/theme/typography'

export const StatGroup = styled.div`
	display: flex;
	gap: 16px;
	margin-bottom: 24px;
	flex-wrap: wrap;
`

export const StatCard = styled.div`
	background-color: ${white};
	border-radius: ${radii.inner};
	padding: 16px 20px;
	box-shadow: ${shadows.inner};
	min-width: 150px;
`

export const StatValue = styled.div`
	font-size: ${fontSizes.display};
	font-weight: 700;
	color: ${blue};
	line-height: ${leading.tight};
	font-variant-numeric: tabular-nums;
`

export const StatLabel = styled.div`
	font-size: ${fontSizes.small};
	color: ${textMuted};
	margin-top: 4px;
`
